import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateEditorComponent } from './template-editor.component';
import { SharedModule } from '@shared/shared.module';
import { TemplateEditorRoutingModule } from './template-editor-routing.module';
import {
    TemplateEditorConfirmComponent,
    TemplateEditorFormComponent,
    TemplateEditorPreviewComponent,
    TemplateEditorSideBarComponent
} from '@app/main/template-editor/components';
import { TemplateBuilderService } from '@app/main/template-editor/services';

@NgModule({
    declarations: [
        TemplateEditorComponent,
        TemplateEditorSideBarComponent,
        TemplateEditorFormComponent,
        TemplateEditorConfirmComponent,
        TemplateEditorPreviewComponent
    ],
    imports: [CommonModule, TemplateEditorRoutingModule, SharedModule],
    exports: [TemplateEditorComponent],
    providers: [TemplateBuilderService]
})
export class TemplateEditorModule {}
